/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScoreEvidenceInput } from './ScoreEvidenceInput';
import {
    ScoreEvidenceInputFromJSON,
    ScoreEvidenceInputFromJSONTyped,
    ScoreEvidenceInputToJSON,
    ScoreEvidenceInputToJSONTyped,
} from './ScoreEvidenceInput';

/**
 * 
 * @export
 * @interface SubmitScoreBody
 */
export interface SubmitScoreBody {
    /**
     * 
     * @type {number}
     * @memberof SubmitScoreBody
     */
    team1Score: number;
    /**
     * 
     * @type {number}
     * @memberof SubmitScoreBody
     */
    team2Score: number;
    /**
     * For Best-of-X series, which game in the series (1, 2, 3, etc.)
     * @type {number}
     * @memberof SubmitScoreBody
     */
    gameNumber?: number;
    /**
     * 
     * @type {Array<ScoreEvidenceInput>}
     * @memberof SubmitScoreBody
     */
    evidence?: Array<ScoreEvidenceInput>;
}

/**
 * Check if a given object implements the SubmitScoreBody interface.
 */
export function instanceOfSubmitScoreBody(value: object): value is SubmitScoreBody {
    if (!('team1Score' in value) || value['team1Score'] === undefined) return false;
    if (!('team2Score' in value) || value['team2Score'] === undefined) return false;
    return true;
}

export function SubmitScoreBodyFromJSON(json: any): SubmitScoreBody {
    return SubmitScoreBodyFromJSONTyped(json, false);
}

export function SubmitScoreBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitScoreBody {
    if (json == null) {
        return json;
    }
    return {
        
        'team1Score': json['team1Score'],
        'team2Score': json['team2Score'],
        'gameNumber': json['gameNumber'] == null ? undefined : json['gameNumber'],
        'evidence': json['evidence'] == null ? undefined : ((json['evidence'] as Array<any>).map(ScoreEvidenceInputFromJSON)),
    };
}

export function SubmitScoreBodyToJSON(json: any): SubmitScoreBody {
    return SubmitScoreBodyToJSONTyped(json, false);
}

export function SubmitScoreBodyToJSONTyped(value?: SubmitScoreBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
        'gameNumber': value['gameNumber'],
        'evidence': value['evidence'] == null ? undefined : ((value['evidence'] as Array<any>).map(ScoreEvidenceInputToJSON)),
    };
}

